import React from 'react';

const CornerDownRightIcon = () => (
  <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18 3V4.05C18 6.57024 18 7.83035 17.5095 8.79296C17.0781 9.63969 16.3897 10.3281 15.543 10.7595C14.5804 11.25 13.3202 11.25 10.8 11.25H2M2 11.25L5.5 7.75M2 11.25L5.5 14.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CornerDownRightIcon;
